module.exports = __webpack_public_path__ + "static/img/best_game.a0649ff7.png";